/*
  Project: Ct Cubed
  Author: Nuno Gaspar
 */

import slidersInit from './modules/sliders-init';
import modals from './modules/modals';
import common from './modules/common';

slidersInit();
modals();
common();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ct-cubed-chisel/src/scripts/app.js